import React, { Suspense } from 'react';

const MapViewComponent = React.lazy(() => import('./MapContainerComponent'));

export const MapLazyComponent: React.FC<{
  isMapViewEnabled: boolean;
  onListViewClickHandler: (listViewClicked: boolean) => void;
  handleNextClick?: (isInitialLoadData: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isDrawerVisible?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onOpenHotelPanel?: (propertyData: any, propertyId: string) => void;
}> = ({ isMapViewEnabled, onListViewClickHandler, handleNextClick, isDrawerVisible, onOpenHotelPanel }) => {
  return (
    <Suspense fallback={''}>
      <MapViewComponent
        isMapViewEnabled={isMapViewEnabled}
        onListViewClickHandler={onListViewClickHandler}
        handleNextClick={handleNextClick}
        isDrawerVisible={isDrawerVisible}
        onOpenHotelPanel={onOpenHotelPanel}
      />
    </Suspense>
  );
};
